module.exports = __webpack_public_path__ + "static/media/getphy-state-active.0f043b3b.svg";